import { createAsyncActionTypes } from '@mews/framework';
import prefix from '../prefix';

export const RESERVATION_FETCH = prefix('RESERVATION_FETCH');
export const RESERVATION_FETCH_STARTED = RESERVATION_FETCH + '_STARTED';
export const RESERVATION_FETCH_SUCCEEDED = RESERVATION_FETCH + '_SUCCEEDED';
export const RESERVATION_FETCH_FAILED = RESERVATION_FETCH + '_FAILED';

export const TIMELINE_RESOURCE_USES_FETCH = prefix('TIMELINE_RESOURCE_USES_FETCH');
export const TIMELINE_RESOURCE_USES_FETCH_STARTED = TIMELINE_RESOURCE_USES_FETCH + '_STARTED';
export const TIMELINE_RESOURCE_USES_FETCH_SUCCEEDED = TIMELINE_RESOURCE_USES_FETCH + '_SUCCEEDED';
export const TIMELINE_RESOURCE_USES_FETCH_FAILED = TIMELINE_RESOURCE_USES_FETCH + '_FAILED';

export const UPDATE_TIMELINE_RESOURCE_USES_FETCH = prefix('UPDATE_TIMELINE_RESOURCE_USES_FETCH');
export const UPDATE_TIMELINE_RESOURCE_USES_FETCH_STARTED = UPDATE_TIMELINE_RESOURCE_USES_FETCH + '_STARTED';
export const UPDATE_TIMELINE_RESOURCE_USES_FETCH_SUCCEEDED = UPDATE_TIMELINE_RESOURCE_USES_FETCH + '_SUCCEEDED';
export const UPDATE_TIMELINE_RESOURCE_USES_FETCH_FAILED = UPDATE_TIMELINE_RESOURCE_USES_FETCH + '_FAILED';

export const RESOURCE_ASSIGNED = prefix('RESOURCE_ASSIGNED');
export const RESOURCE_ASSIGNED_STARTED = RESOURCE_ASSIGNED + '_STARTED';
export const RESOURCE_ASSIGNED_SUCCEEDED = RESOURCE_ASSIGNED + '_SUCCEEDED';
export const RESOURCE_ASSIGNED_FAILED = RESOURCE_ASSIGNED + '_FAILED';

export const UPDATE_ASSIGNED_RESOURCE_FIXED_FETCH = prefix('UPDATE_ASSIGNED_RESOURCE_FIXED_FETCH');
export const UPDATE_ASSIGNED_RESOURCE_FIXED_FETCH_STARTED = UPDATE_ASSIGNED_RESOURCE_FIXED_FETCH + '_STARTED';
export const UPDATE_ASSIGNED_RESOURCE_FIXED_FETCH_SUCCEEDED = UPDATE_ASSIGNED_RESOURCE_FIXED_FETCH + '_SUCCEEDED';
export const UPDATE_ASSIGNED_RESOURCE_FIXED_FETCH_FAILED = UPDATE_ASSIGNED_RESOURCE_FIXED_FETCH + '_FAILED';

export const RANGES_FETCH = prefix('RANGES_FETCH');
export const RANGES_FETCH_STARTED = RANGES_FETCH + '_STARTED';
export const RANGES_FETCH_FAILED = RANGES_FETCH + '_FAILED';
export const RANGES_FETCH_SUCCEEDED = RANGES_FETCH + '_SUCCEEDED';

export const BLOCKS_FETCH = prefix('BLOCKS_FETCH');
export const [BLOCKS_FETCH_STARTED, BLOCKS_FETCH_SUCCEEDED, BLOCKS_FETCH_FAILED] = createAsyncActionTypes(BLOCKS_FETCH);

export const RESET = prefix('RESET');
export const NEW_HOUSE_USE_CLICKED = prefix('NEW_HOUSE_USE_CLICKED');
export const RANGE_CHANGED = prefix('RANGE_CHANGED');
export const BLOCK_CHANGED = prefix('BLOCK_CHANGED');
export const LAST_UPDATE_START_CHANGED = prefix('LAST_UPDATE_START_CHANGED');
export const RESOURCE_USES_MODIFIED = prefix('RESOURCE_USES_MODIFIED');
export const CUSTOMERS_CHANGED = prefix('CUSTOMERS_CHANGED');
export const RESOURCE_USE_SELECTED = prefix('RESOURCE_USE_SELECTED');
export const RESOURCE_USE_DESELECTED = prefix('RESOURCE_USE_DESELECTED');
export const CHANGE_DENSITY = prefix('CHANGE_DENSITY');
export const CHANGE_DENSITY_PERCENTAGE = prefix('CHANGE_DENSITY_PERCENTAGE');
export const CHANGE_TIME_UNIT = prefix('CHANGE_TIME_UNIT');

export const OPTIMIZE_ASSIGNMENT = prefix('OPTIMIZE_ASSIGNMENT');
export const [OPTIMIZE_ASSIGNMENT_STARTED, OPTIMIZE_ASSIGNMENT_SUCCEEDED, OPTIMIZE_ASSIGNMENT_FAILED] =
    createAsyncActionTypes(OPTIMIZE_ASSIGNMENT);

export const VIEWPORT_CHANGED = prefix('VIEWPORT_CHANGED');

export const PREVIEW_DIALOG_TOGGLED = prefix('PREVIEW_DIALOG_TOGGLED');
export const PREVIEW_REQUEST_STARTED = prefix('PREVIEW_REQUEST_STARTED');

export const CANCEL_OPTIMIZATION = prefix('CANCEL_OPTIMIZATION');

export const MONTH_VIEW_RESERVATION_LENGTH_RESTRICTION_INFO_MESSAGE_DISPLAYED = prefix(
    'MONTH_VIEW_RESERVATION_LENGTH_RESTRICTION_INFO_MESSAGE_DISPLAYED'
);

export const TIMELINE_INIT = prefix('TIMELINE_INIT');
export const [TIMELINE_INIT_STARTED, TIMELINE_INIT_SUCCEEDED, TIMELINE_INIT_FAILED] =
    createAsyncActionTypes(TIMELINE_INIT);

export const OPEN_AVAILABILITY_WARNING_DIALOG = prefix('OPEN_AVAILABILITY_WARNING_DIALOG');
export const CLOSE_AVAILABILITY_WARNING_DIALOG = prefix('CLOSE_AVAILABILITY_WARNING_DIALOG');
